import { Content } from "@/ui/Content";
import * as additionalComponents from "@/components/ContactPage";
import { router } from "@/router";
import { stripTags } from "@/functions/stripTags";
import { getGlobal } from "@/functions/getGlobal";
import sourceflowEnums from "@/sourceflow.enums";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({}) {
  const global = getGlobal();
  const routerProp = router["contact"];
  const titleKey = "page.contact.banner.title";

  return {
    props: {
      meta: {
        en: {
          title: stripTags(global[`${titleKey}.en`]),
          canonical: `${sourceflowEnums.config.baseUrl}${routerProp["en"]}`,
        },
      },
      router: routerProp,
      content: [
        { component: "ContactPageBannerSection", props: { className: "" } },
        { component: "ContactPageOfficesSection", props: { className: "py-4 py-md-5" } },
        { component: "ContactPageFormSection", props: { className: "pb-md-5 mb-md-5" } },
      ],
      footer: {
        showForm: false,
      },
    },
  };
}
